<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Costo por Proyecto {{ form.nombre }}</h3>
        <label>
          <div v-show="form.estado == 'N'" class="noti-secondary">Estado: <strong>NUEVO</strong></div>
          <div v-show="form.estado == 'A'" class="noti-success">Estado: <strong>ACTIVO</strong></div>
          <div v-show="form.estado == 'I'" class="noti-danger">Estado: <strong>INACTIVO</strong></div>
        </label>
      </div>
      <div class="layout__controls">
        <button v-if="consultar" @click="botonBuscar()" class="btn-info btn--bigger">
          <i class="fa fa-search"></i>
          <span>Buscar</span>
        </button>
      </div>
    </div>
    <div class="layout__main">
      <div class="layout__main-form">
        <div class="card">
          <div class="card__content">
            <div class="row">
              <div class="col-xs-12 col-md-6">
                <div class="form-field select2">
                  <div class="form-group">
                    <div class="select2-field">
                      <v-select
                        :disabled="disabledInput"
                        :tooltip="selectedProyecto?selectedProyecto.nombre:null"
                        v-model="selectedProyecto"
                        @search="onSearchProyecto"
                        @input="inputProyecto"
                        id="proyecto_id"
                        placeholder="Busque y seleccione..."
                        label="nombre"
                        :options="optionProyectos"
                      ></v-select>
                      <label for="proyecto_id">Proyecto*</label>
                      <span v-if="errores.proyecto_id" class="helper-text text-danger" slot="helper">
                        <strong>{{ errores.proyecto_id[0] }}</strong>
                      </span>
                    </div>
                    <button :disabled="disabledInput" @click="buscarProyecto()" class="btn-info" type="button">
                      <i class="fa fa-search"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-md-6">
                <div class="form-field">
                  <div class="datepicker-field datepicker-field--stretch">
                    <VueCtkDateTimePicker
                      :disabled="disabledInput"
                      id="fecha"
                      v-model="form.fecha"
                      locale="es"
                      only-datetime
                      no-label
                      button-now-translation="Ahora"
                      format="YYYY-MM-DD HH:mm"
                      formatted="YYYY-MM-DD HH:mm"
                      label="Seleccione fecha..."
                    />
                    <label>Fecha*</label>
                    <span v-if="errores.fecha" class="helper-text text-danger" slot="helper">
                      {{ errores.fecha[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-md-6">
                <div class="form-field">
                  <input-field :disabled="disabledInput" v-model="form.descripcion" id="descripcion" placeholder="Escriba una descripción...">
                    <span>Descripción*</span>
                    <span v-if="errores.descripcion" class="helper-text text-danger" slot="helper">
                      {{ errores.descripcion[0] }}
                    </span>
                  </input-field>
                </div>
              </div>
              <div class="col-xs-12 col-md-6">
                <div class="form-field">
                  <input-field :disabled="disabledInput" v-model="form.valor" id="valor" vMoney :format="money" type="tel" placeholder="$ ##.##">
                    <span>Valor*</span>
                    <span v-if="errores.valor" class="helper-text text-danger" slot="helper">
                      {{ errores.valor[0] }}
                    </span>
                  </input-field>
                </div>
              </div>
              <div class="col-xs-12 col-md-6">
                <div class="form-field">
                  <input-field :disabled="disabledInput" v-model="form.observacion" id="observacion" placeholder="Escriba una observación...">
                    <span>Observación</span>
                    <span v-if="errores.observacion" class="helper-text text-danger" slot="helper">
                      {{ errores.observacion[0] }}
                    </span>
                  </input-field>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="layout__main-buttons">
        <div class="card">
          <div class="card__content">
            <button v-if="crear && editar" :disabled="form.estado == 'I'" @click="botonGuardar()" class="btn-success" type="button"><i class="fa fa-save"></i><span>Guardar</span></button>
            <button @click="botonLimpiar()" class="btn-light btn--text" type="button"><i class="fa fa-plus"></i><span>Nueva</span></button>
            <button v-if="eliminar" @click="botonAnular()" v-show="tieneId && (form.estado != 'N' && form.estado != 'I')" type="button" class="btn-danger btn--text"><i class="fa fa-ban"></i> <span>Eliminar</span></button>
            <button @click="botonReactivar()" v-show="tieneId && form.estado == 'I'" type="button" class="btn-success btn--text"><i class="fa fa-power-off"></i><span>Re-activar</span></button>
          </div>
        </div>
      </div>
    </div>
    <modal :width="'80%'" height="auto" :scrollable="true" name="modalListaCostoProyectos">
      <listaCostoProyectos
        enabledExcel
        @selected="seleccionarCostoProyecto"
      />
    </modal>
  </div>
</template>
<script>
export default {
  props: {
    consultar: {
      type: Boolean,
      required: false,
    },
    crear: {
      type: Boolean,
      required: false,
    },
    editar: {
      type: Boolean,
      required: false,
    },
    eliminar: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      money,
      selectedProyecto: null,
      optionProyectos: [],
      form: {
        id: '',
        proyecto_id: '',
        fecha: '',
        descripcion: '',
        valor: '',
        observacion: '',
        estado: 'N',
      },
      errores: {
        proyecto_id: undefined,
        fecha: undefined,
        descripcion: undefined,
        valor: undefined,
        observacion: undefined,
      }
    }
  },
  computed: {
    tieneId: function(){
      return this.form.id != '' && this.form.id != null;
    },
    disabledInput: function(){
      return this.form.estado == 'I';
    }
  },
  methods: {
    botonBuscar: function(){
      this.$modal.show('modalListaCostoProyectos');
    },
    seleccionarCostoProyecto: function(row){
      this.form.id = row.id;
      this.selectedProyecto = row.proyecto;
      this.form.proyecto_id = row.proyecto_id;
      this.form.fecha = row.fecha;
      this.form.descripcion = row.descripcion;
      this.form.valor = row.valor;
      this.form.observacion = row.observacion;
      this.form.estado = row.estado;
      this.$modal.hide('modalListaCostoProyectos');
    },
    limpiarCampos: function(){
      this.form.id = '';
      this.form.proyecto_id = '';
      this.form.fecha = '';
      this.form.descripcion = '';
      this.form.valor = '';
      this.form.observacion = '';
      this.form.estado = 'N';
      this.selectedProyecto = null;
    },
    limpiarErrores: function(){
      this.errores.proyecto_id = undefined;
      this.errores.fecha = undefined;
      this.errores.descripcion = undefined;
      this.errores.valor = undefined;
      this.errores.observacion = undefined;
    },
    botonLimpiar: function(){
      swal.fire({
        title: '¿Está seguro de limpiar el formulario?',
        text: "Se perderán los datos que no hayan sido guardados.",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33'
      }).then((result) => {
        if (result.value) {
          this.limpiarCampos();
          this.limpiarErrores();
        }
      })
    },
    buscarProyecto: function(){
      this.$modal.show('listaProyectos');
    },
    onSearchProyecto: function(search, loading) {
      if(search.length) {
        loading(true);
        this.searchingProyecto(loading, search, this);
      }
    },
    searchingProyecto: _.debounce((loading, search, vm) => {
      fetch(`${url}/proyectos/search/${search}`, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      }).then(response => response.json()).then(data => {
        vm.optionProyectos = data;
        loading(false);
      });
    }, 350),
    inputProyecto: function() {
      if(this.selectedProyecto)
        this.form.proyecto_id = this.selectedProyecto.id;
      else{
        this.form.proyecto_id = '';
        this.selectedProyecto = null;
      }
    },
    guardarDatos: function(btn_estado = null){
      let title = '¿Deseas guardar el costo por proyecto?';
      if(this.tieneId && btn_estado != null){
        if(btn_estado == 'A')
          title = '¿Deseas Anular el costo por proyecto?';
        else if(btn_estado == 'R')
          title = '¿Deseas Re-activar el costo por proyecto?';
      }
      swal.fire({
        title,
        text: "Esta acción requiere de confirmación.",
        type: 'question',
        showCancelButton: true,
        confirmButtonText:'Aceptar'
      }).then((result) => {
        if (result.value) {
          this.limpiarErrores();
          let urlApi = null, method = 'POST';
          if(this.tieneId){
            if(btn_estado == 'A' || btn_estado == 'R'){
              urlApi = url + '/costos-proyectos/delete/' +this.form.id;
              method = 'DELETE';
            }
            else{
              urlApi = url + '/costos-proyectos/update/' +this.form.id;
              method = 'PUT';
            }
          }
          else
            urlApi = url + '/costos-proyectos/store';
          axios({
            method,
            url: urlApi,
            data: this.form
          }).then(response => {
            this.form.id = response.data.id;
            this.form.estado = response.data.estado;
            swal.fire('Aviso', 'El costo por proyecto han sido almacenado.', 'success');
          }).catch(error => {
            if(error !== undefined && error !== null){
              let response = error.response;
              if (response !== undefined && response !== null){
                let status = response.status;
                if(status === 422){
                  this.errores = response.data.errors;
                  swal.fire('Hubo un error en el formulario.', 'Aviso', 'warning');
                  return;
                }
              }
            }
            swal.fire('Hubo un error, intente nuevamente.', 'Error', 'error');
          });
        }
      });
    },
    botonGuardar: function(){
      if(this.disabledInput)
        return;
      this.guardarDatos();
    },
    botonAnular: function(){
      this.guardarDatos('A');
    },
    botonReactivar: function(){
      this.guardarDatos('R');
    },
  },
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/procesos/CostoProyecto.vue